import { z } from 'zod';

const DEFAULT_PASSWORD_RULES: PasswordRules = {
  upper: true,
  numbers: true,
  special: true,
  length: 16,
};

interface PasswordRules {
  length: number;
  upper: boolean;
  numbers: boolean;
  special: boolean;
}

const PasswordRules = z.object({
  length: z.number(),
  upper: z.boolean(),
  numbers: z.boolean(),
  special: z.boolean(),
});

export { PasswordRules, DEFAULT_PASSWORD_RULES };
